window.oImportTemplatesGet = function(importContainer, sImportUrl, alphabet)
{
	if(typeof(sImportUrl) == "undefined") sImportUrl = "/qimport";

	var oImportTemplates =
	{
		importContainer: 	null,
		aNames: 			['use','update','save','delete', 'templates', 'useColumn'],
		aButtons: 			['importConfirm', 'confirmDelete'],
		aTemplatesBox: 		[],
		oBinds: 			null,
		$importTable: 		null,
		$editErrors: 		null,
		$responseFiles: 	null,
		$responseButtons: 	null,
		$importResult: 		null,
		$file: 				null,
		$bUpdateErrors: 	true,
		alphabet: 			[],
		lineClass: 			['odd', 'even'],
		checkboxChanges:
		{
			// click
			confirmDelete: function(e)
			{
				var $this = e.data.this;

				var formdata = false;
			    if (window.FormData)
			    {
			        formdata = new FormData();
			    }
				if(formdata)
				{
					var deleteTemplate = $this.importContainer.find('select[name=default-template]').val()||'';
					formdata.append("deleterun",true);
					formdata.append("defaultTemplate",deleteTemplate)
		            jQuery.ajax({
		            	dataType: "json",
		                url: sImportUrl,
		                type: "POST",
		                data: formdata,
		                processData: false,
		                contentType: false,
		                success: function (data)
		                {
		                	if( data.result.length && deleteTemplate.length )
		                	{
		                		$this.aTemplatesBox['templates'].find("option[value='"+deleteTemplate+"']").remove();
								if( !$this.aTemplatesBox['templates'].find('option').length )
								{
									$this.aTemplatesBox['templates'].append("<option value='-1'>Пусто</option>");

									$this.checked(['use','save'], true);
									$this.checked(['update','delete'], false);
									$this.disabled(['use','save'], false);
									$this.disabled(['update','delete'], true);
								}
								else
								{
									$this.aTemplatesBox['templates'].trigger('change');
								}
		                	}
		                }
		            });
				}

			},
			importConfirm: function(e)
			{
				var $this = e.data.this;

				$this.$importResult = $this.importContainer.find('.import-result');

				var $oUses 			= $this.$importTable.find('input[type=checkbox]:checked'),
				$oEditdata 			= $this.$editErrors.find('input[type=text]'),
				aUse 				= $this.aData($oUses, 'value'),
				aBind 				= $this.aData($this.oBinds.find("option:selected"), 'value'),
				aEditdata 			= $this.aData($oEditdata, 'value'),
				aEditdataParam 		= $this.aData($oEditdata, 'param'),
				$importResultEdit 	= $this.$importResult.find('input[type=text]'),
				$saveNewTemplate 	= $this.importContainer.find('input[name=save-new-template]:checked'),
				$useTemplateDefault = $this.importContainer.find('input[name=use-template-default]:checked'),
				$updateTemplate 	= $this.importContainer.find('input[name=update-template]:checked'),
				$deleteTemplate 	= $this.importContainer.find('input[name=delete-template]:checked'),
				$templateName 		= $this.importContainer.find('input[name=template-name]'),
				$defaultTemplate 	= $this.importContainer.find('select[name=default-template]'),
				$user_id 			= $this.importContainer.find('input[name=user-id]'),
				$belongsto 			= $this.importContainer.find('input[name=belongsto]'),
				$file_id 			= $this.importContainer.find('input[name=file_id]'),
				$outline 			= $this.importContainer.find('input[name=out-line]'),
				$onlyCheck 			= $this.importContainer.find('input[name=only-check]');

				$this.$importResult.html("<img src='/img/loaders/smallcircle.gif' /> Подождите, данные импортируются ...");

				var formdata = false;
			    if (window.FormData)
			    {
			        formdata = new FormData();
			    }
			    if (formdata)
		        {
		        	var oParent = $('#request_uri input');
					oParent.each(function(i, j){
						formdata.append($(this).attr('name'),$(this).val());
					});
		            formdata.append("file", $this.importContainer.find('input[type=file]').prop("files")[0]);
		            formdata.append("use",aUse);
					formdata.append("bind",aBind);
					formdata.append('editdata', aEditdata);
					formdata.append('editdataParam', aEditdataParam);
					formdata.append("saveNewTemplate",($saveNewTemplate.val()||''));
					formdata.append("useTemplateDefault",($useTemplateDefault.val()||''));
					formdata.append("templateName",($templateName.val()||''));
					formdata.append("defaultTemplate",($defaultTemplate.val()||''));
					formdata.append("updateTemplate",($updateTemplate.val()||''));
					formdata.append("deleteTemplate",($deleteTemplate.val()||''));
					formdata.append("user_id",$user_id.val());
					formdata.append("belongsto",$belongsto.val());
					formdata.append("id",$file_id.val());
					formdata.append("run",true);
					formdata.append("outline", $outline.val());
					formdata.append("bOnlyCheck", ( $onlyCheck.prop("checked") ) ? 1 : 0 );
		            jQuery.ajax({
		            	dataType: "json",
		                url: "/qimport",
		                type: "POST",
		                data: formdata,
		                processData: false,
		                contentType: false,
		                success: function (data)
		                {
		                	$this.$bUpdateErrors = false;
		                	if( data.result == "goodcheck" )
		                	{
		                		$onlyCheck.prop("checked", false); // Отклчаем проверку по умолчанию
								/////////////////////////////////////
								// Обновили список шаблонов
								if( data.newTemplate )
								{
									if( parseInt($this.aTemplatesBox['templates'].val()) == -1 )
									{
										$this.aTemplatesBox['templates'].html(data.newTemplate);
									}
									else
									{
										$this.aTemplatesBox['templates'].append(data.newTemplate);
									}
								}
								/////////////////////////////////////
								// Обновляем шаблон по умолчанию
								if(data.updateTemplate && data.updateTemplateParam)
								{
									$this.aTemplatesBox['templates'].find("option[value='"+data.updateTemplate+"']").attr('param', data.updateTemplateParam);
								}

								if( data.newDefault )
								{
									$this.aTemplatesBox['templates'].find('option').removeAttr('checked');
									$this.aTemplatesBox['templates'].val(data.newDefault).change();
								}

								if( data.deleteTemplate )
								{
									$this.aTemplatesBox['templates'].find("option[value='"+data.deleteTemplate+"']").remove();
									if( !$this.aTemplatesBox['templates'].find('option').length )
									{
										$this.aTemplatesBox['templates'].append("<option value='-1'>Пусто</option>");

										$this.checked(['use','save'], true);
										$this.checked(['update','delete'], false);
										$this.disabled(['use','save'], false);
										$this.disabled(['update','delete'], true);
									}
									else
									{
										$this.aTemplatesBox['templates'].trigger('change');
									}
								}

		                		return $this.aTemplatesBox['importConfirm'].trigger('click');
		                	}

		                	if(typeof data.result == "string")
		                	{
		                		$this.$editErrors.html('');
		                		$this.$importResult.html(data.result);
		                		$this.checked(['use','update','save','delete'], false);
								$this.disabled(['use','update','save','delete'], false);
								$templateName.val('');
		                	}
		                	else
		                	{
		                		var editHtml = '',
		                		editHtmlFull = '',
		                		html = '',
		                		iOutline = data.outline;

			                	if( $onlyCheck.prop("checked") )
			                	{
			                		// Анализируем полученные данные
			                		var aboutWarning, iUse, columns = 0, k = 0, v = 1;
			                		for(var i in data.result)
			                		{
			                			data.result[i] = $this.bubbleSort(data.result[i]);
			                			var jLength = data.result[i].length;
			                			for(var j=0; j < jLength; j++ )
			                			{
			                				columns = ( (parseInt(data.result[i][j]) + 1) > columns ) ? (parseInt(data.result[i][j]) + 1) : columns;
			                				if( j+1 < jLength )
			                				{
			                					if( parseInt(data.result[i][j][0]) == parseInt(data.result[i][j+1][0]) )
			                					{
			                						data.result[i][j+1][2] += "<br>" + data.result[i][j][2];
			                						if (data.result[i][j+1][1] == null) data.result[i][j+1][1] = "";
			                						if( data.result[i][j+1][1].length < data.result[i][j][1].length )
		                							{
		                								data.result[i][j+1][1] = data.result[i][j][1];
		                							}
			                					}
			                				}
			                			}
			                		}

			                		if( !aEditdata.length )
			                		{
			                			var iLine = 0,
			                			useObj = $this.$importTable.find('input[type=checkbox]:checked').closest('tr[use=use]');
			                			editHtmlFull = "<table class='import-table table table-bordered table-condensed qlist-table dataTable'>";
										editHtmlFull += "<tr>";
										editHtmlFull += "<th>Строка №</th>";
										for( var j = 0; j < columns; j++ ) editHtmlFull += "<th>"+$this.alphabet[j]+"</th>";
										editHtmlFull += "</tr>";
										for(var i in data.result)
										{
											while( $.inArray(iLine, data.outline) > -1 ) iLine++;
											v = 1 - v;
											k = 0;
											editHtml = '';
											editHtmlFull += "<tr class='"+$this.lineClass[v]+"'><th>Строка "+( parseInt(i)+1+iLine )+"</th>";
											for( var j = 0; j < columns; j++ )
											{
												if( data.result[i][k] && data.result[i][k].length )
												{
													if( data.result[i][k][0] == j )
													{
														while( data.result[i][k+1] && data.result[i][k+1][0] == j ) k++;
														iUse = useObj.find('option[value='+j+']:selected').length;
														aboutWarning = data.result[i][k][2]||"";
														editHtml += "<td class='empty-line'><center>";
														editHtml += "<input type='text' name='editdata[]' param='"+i+"_"+j+"' value='"+(data.result[i][k][1]||"")+"'>";
														if( aboutWarning.length ) editHtml += "<br><div class='aboutMess'>("+aboutWarning+")</div>";
														if( iUse > 1 ) editHtml += "<br><div class='signMess'>(Строка должна удовлетворять "+iUse+" соответствиям!)</div>"
														editHtml += "</center></td>";
														k++;
													}
													else
													{
														editHtml += $this.warningColumn(data.aWarningsLines[i][0][j]||'');
													}
												}
												else
												{
													editHtml += $this.warningColumn(data.aWarningsLines[i][0][j]||'');
												}
											}

											editHtmlFull += editHtml;
											editHtmlFull += "</tr>";
										}
										editHtmlFull += "</table>";
										$this.$editErrors.html(editHtmlFull);
			                		}
			                		else
			                		{
			                			$oEditdata.attr('disabled', true);
			                			$oEditdata.closest('tr').hide();
			                			for(i in data.result)
			                			{
			                				for(j in data.result[i])
				                			{
				                				var element = $this.$editErrors.find('input[param='+i+'_'+(parseInt(data.result[i][j][0]))+']');
				                				if( element )
				                				{
				                					element.closest('tr').show();
				                					element.attr('disabled', false);
				                				}
				                			}
			                			}
			                		}
			                		$this.$importResult.html('Необходимо исправить ошибки в указанных столбцах.');
			                	}
			                	else
			                	{
			                		$this.$editErrors.html('');
			                		$this.$importResult.html(data.result);
			                	}
		                	}
		                	$onlyCheck.prop("checked", true);
							$this.$bUpdateErrors = true;
		                }
		            });
		        }
		        else
		        {
		            $this.$importResult.html("Ошибка при загрузке файла.");
		        }
			},
			use: function(e)
			{
				var $this = e.data.this;
				if( $(this).prop("checked") )
				{
					$this.checked(['delete'], false);
					$this.disabled(['delete'], true);
				}
				else
				{
					if( parseInt($this.aTemplatesBox['templates'].val()) != -1
						&& !$this.aTemplatesBox['save'].prop("checked")
						&& !$this.aTemplatesBox['update'].prop("checked") ) $this.disabled(['delete'], false);
				}
			},
			update: function(e)
			{
				var $this = e.data.this;
				if( $(this).prop('checked') )
				{
					$this.checked(['save', 'delete'], false);
					$this.disabled(['save', 'delete'], true);
				}
				else
				{
					$this.disabled(['save'], false);
					if( !$this.aTemplatesBox['use'].prop("checked") ) $this.disabled(['delete'], false);
				}
			},
			save: function(e)
			{
				var $this = e.data.this;
				if( $(this).prop("checked") )
				{
					$this.$importTable.find('input[type=checkbox]').attr('checked', true);
					$this.$importTable.find('select [value="0"]').attr('selected', 'selected');
					$this.checked(['update', 'delete'], false);
					$this.disabled(['update', 'delete'], true);
				}
				else
				{
					if( parseInt($this.aTemplatesBox['templates'].val()) != -1 )
					{
						$this.disabled(['update'], false);
						if(!$this.aTemplatesBox['use'].prop("checked")) $this.disabled(['delete'], false);
					}
					$this.aTemplatesBox['templates'].trigger('change');
				}
			},
			delete: function(e)
			{
				var $this = e.data.this, bDisables = false;
				if( $(this).prop('checked') )
				{
					$this.checked(['use','update', 'save'], false);
					$this.disabled(['use','update', 'save'], true);
				}
				else
				{
					$this.disabled(['use','update', 'save'], false);
				}
			},
			templates: function(e)
			{
				var $this = e.data.this,
				$oUse = $this.$importTable.find('input[type=checkbox]'),
				sParam = $(this).find('option:selected').first().attr('param')||null;

				$this.oBinds = $this.$importTable.find('select');

				if(sParam)
				{
					var aParams = sParam.split(","),
					aParam = [];
					for(var i in aParams)
					{
						var aItems = aParams[i].split("=>");
						aParam[aItems[0]] = aItems[1];
					}
					$this.oBinds.each(function(i)
					{
						if( aParam[i] )
						{
							$oUse.eq(i).attr("checked","checked");
							$(this).find("option[value='"+aParam[i]+"']").attr("selected", "selected")
						}
						else
						{
							$oUse.eq(i).removeAttr("checked");
							$(this).find("option[value='0']").attr("selected", "selected")
						}

					});
				}
				$this.clear();
			},
			useColumn: function(e)
			{
				e.data.this.clear();
			}
		},
		ini: function(importContainer, alphabet) // Выполняется каждый раз при загрузке нового файла!
		{
			this.importContainer = importContainer;

			this.$importTable 		= this.importContainer.find('#response-changes'),
			this.$editErrors 		= this.importContainer.find('#edit-errors');
			this.$responseFiles 	= this.importContainer.find('#response-file');
		    this.$responseButtons 	= this.importContainer.find('#response-buttons');
		    this.$importResult 		= this.importContainer.find('.import-result');
		    this.$file 				= this.importContainer.find('#file');
			this.oBinds 			= this.$importTable.find('select');

			var i = 0;
			this.aTemplatesBox[this.aNames[i++]] 	= this.importContainer.find('input[name=use-template-default]');
			this.aTemplatesBox[this.aNames[i++]] 	= this.importContainer.find('input[name=update-template]');
			this.aTemplatesBox[this.aNames[i++]] 	= this.importContainer.find('input[name=save-new-template]');
			this.aTemplatesBox[this.aNames[i++]] 	= this.importContainer.find('input[name=delete-template]');
			this.aTemplatesBox[this.aNames[i++]] 	= this.importContainer.find('select[name=default-template]');
			this.aTemplatesBox[this.aNames[i++]] 	= this.$importTable.find('tr[use=use]').find('input[type=checkbox]');

			i = 0;
			this.aTemplatesBox[this.aButtons[i++]] 	= this.importContainer.find('#import-confirm');
			this.aTemplatesBox[this.aButtons[i++]] 	= this.importContainer.find('.btn.btn-danger.DoneButton');

			this.alphabet = alphabet;

			this.oBinds.on('change', {this: this}, this.bindsChange);

			this.iniHandlers(this.aNames, 'change');
			this.iniHandlers(this.aButtons, 'click');

			if( parseInt(this.aTemplatesBox['templates'].val()) == -1 ) this.disabled(['delete', 'update'], true);
			return this;
		},
		warningColumn: function(sData)
		{
			return "<td>" + sData + "</td>";
		},
		bindsChange: function(e)
		{
			e.data.this.clear();
		},
		bubbleSort: function (A)
		{
		    var n = A.length;
		    for (var i = 0; i < n-1; i++)
		    {
		    	for (var j = 0; j < n-1-i; j++)
		       	{
		       		if (parseInt(A[j+1][0]) < parseInt(A[j][0]))
		            {
		            	var t = A[j+1]; A[j+1] = A[j]; A[j] = t;
		            }
		        }
		    }
		    return A;
		},
		clear: function()
		{
			if( this.$bUpdateErrors ) this.$editErrors.html(null);
    		this.$importResult.html(null);
		},
		iniHandlers: function(aNames, sHandler)
		{
			for( var i in aNames ) this.aTemplatesBox[aNames[i]].on(sHandler, {this: this}, this.checkboxChanges[aNames[i]]);
		},
		is_checked: function(name)
		{
			return this.aTemplatesBox[name].prop('checked');
		},
		checked: function(aNames, bParam)
		{
			for( var i in aNames ) this.aTemplatesBox[aNames[i]].prop('checked', bParam);
		},
		disabled: function(aNames, bParam)
		{
			for( var i in aNames ) this.aTemplatesBox[aNames[i]].prop('disabled', bParam);
		},
		refresh: function(importContainer)
		{
			this.ini(importContainer);
			this.aTemplatesBox['templates'].trigger('change');
		},
		//////////////////////////
		//////////////////////////
		// OButtons
		//////////////////////////
		//////////////////////////
		aData: function($aObjects, attr)
		{
			var aData = [];
			$aObjects.each(function(i)
			{
				aData[i] = $(this).attr(attr);
			});
			return aData;
		}
	}
	return oImportTemplates.ini(importContainer, alphabet);
}

window.oImportGet = function(importContainer, sImportUrl)
{
	if(typeof(sImportUrl) == "undefined") sImportUrl = "/qimport"

	var oImport =
	{
		$input: 			null,
		$responseChanges: 	null,
		$responseTemplates: null,
		$responseFiles: 	null,
		$responseButtons: 	null,
		$outline: 			null,
		$belongsto: 		null,
		formdata: 			false,
		alphabet: 			[],
		ini: function(importContainer)
		{
			this.$input 			= importContainer.find('input[type=file]');
			this.$responseChanges 	= importContainer.find('#response-changes');
		    this.$responseTemplates = importContainer.find('#response-templates');
		    this.$responseFiles 	= importContainer.find('#response-file');
		    this.$responseButtons 	= importContainer.find('#response-buttons');
		    this.$outline 			= importContainer.find('input[name=out-line]');
		    this.$belongsto 		= importContainer.find('input[name=belongsto]');

		    if (window.FormData) this.formdata = new FormData();

		    this.$input.on('change', {this: this}, this.change);
		    this.$outline.on('keyup', {this: this}, this.keyup);

		    var j = 0;
			for (var i=65; i<=90; i++,j++) this.alphabet[j] = String.fromCharCode(i);
			for (var i2=65; i2<=90; i2++)
			{
				for (var i3=65; i3<=90; i3++,j++) this.alphabet[j] = String.fromCharCode(i2) + String.fromCharCode(i3);
			}
		    return this;
		},
		change: function(e)
		{
			var $this = e.data.this;
			if ($this.formdata)
	        {
	            $this.formdata.append("file", this.files[0]);
	            $this.formdata.append("belongsto", $this.$belongsto.val());
	            $this.formdata.append("outline", $this.$outline.val());
	            jQuery.ajax({
	                dataType: "json",
	                url: sImportUrl,
	                type: "POST",
	                data: $this.formdata,
	                processData: false,
	                contentType: false,
	                success: function (data)
	                {
	                	if( data.result )
	                	{
	                		$this.$responseFiles.html(data.result);
	                	}
	                	else
	                	{
	                		$this.$responseChanges.html(data.changes);
		                    $this.$responseFiles.html(data.file);
		                    $this.$responseButtons.html(data.buttons);
		                    oImportTemplatesGet(importContainer, sImportUrl, $this.alphabet);
	                	}
	                }
	            });
	        }
	        else
	        {
	            $this.$responseFiles.html("Ошибка при загрузке файла.");
	        }
		},
		keyup: function(e)
		{
			var $this = e.data.this;
			if( $this.$input.val().length ) $this.$input.trigger('change');
		}
	}
	return oImport.ini(importContainer);
}
